// Lê os globals do env.js (gerado pelo Jenkins a cada deploy e compartilhado com
// o login.html legado, D3). O env.js é carregado como
// <script> clássico antes deste bundle (ver vite.config.ts, plugin inject-legacy-env),
// então cria propriedades reais em window.
//
// Ver docs/migracao/decisoes.md e plano, seção A.6.

declare global {
  interface Window {
    BASE_URL_MS?: string;
    BASE_URL?: string;
  }
}

function normalize(value: string | undefined, fallback: string): string {
  return (value ?? fallback).trim().replace(/\/+$/, '');
}

// Fallbacks só para dev sem env.js carregado (ex.: testes). Em produção o env.js
// sempre define os dois.
export const BASE_URL_MS = normalize(window.BASE_URL_MS, 'http://localhost:5555');
export const BASE_URL = normalize(window.BASE_URL, window.location.origin);
export const LOGIN_URL = `${BASE_URL}/login`;
